import React from 'react';

import TableUI from '../TableUI';

export default React.memo( ( {
  getTableProps, getRowProps, headerGroups, page, prepareRow, filters, setFilter,
  customFilters, setGlobalFilter, globalFilter, setMultipleFilters,
} ) => (
  <>
    {customFilters ? customFilters( {
      filters, setFilter, globalFilter, setGlobalFilter, setMultipleFilters,
    } ) : null}

    <div className="py-2">
      <TableUI
        page={page}
        headerGroups={headerGroups}
        prepareRow={prepareRow}
        getTableProps={getTableProps}
        getRowProps={getRowProps}
      />
    </div>
  </>
) );
